/**
 *
 * FBAppointmentPreview
 *
 */

import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Radio, Checkbox } from 'antd';

// layout components
import ErrorBoundary from 'engine/ErrorBoundary';

// Communication components
import {
  FBSectionHeader,
} from 'components/Communications';

// custom react-multi-date-picker
import { DateObject } from 'react-multi-date-picker';
import { timeFormat, dateFormat } from 'utils/moment/moment.constant';

// icons
import CustomIcons from 'components/CustomIcons';


function FBAppointmentPreview({
  type,
  appointments,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-appointment-group-preview', 'tcf-fb-group-preview', className);

  const formatDateTimeValue = useCallback((value, format) => {
    if (!!!value) {
      return '';
    }

    if (typeof value == 'object') {
      return !!value && value.format(format);
    } else {
      return !!value && new DateObject(value).format(format);
    }

  }, [])

  const prepearGroup = useCallback((fields, type, name) => {
    let gruopOptions = [];
    if (!!fields?.['field-input'] && type) {
      gruopOptions = fields?.['field-input']?.map((opt, indx) => {
        const timeFrom = formatDateTimeValue(opt?.[`time-from`], timeFormat);
        const timeTo = formatDateTimeValue(opt?.[`time-to`], timeFormat);
        const label = `${timeFrom} - ${timeTo}`;
        return timeFrom && timeTo && {
          label,
          value: `${opt?.[`time-from`]} - ${opt?.[`time-to`]}`,
          key: `${type}-${name}-${indx}`
        }
      }).filter(el => !!el && Object.keys(el)?.length > 0)
    }
    return gruopOptions;
  }, [appointments])

  const generatePreviewByType = useCallback((row, name) => {
    switch (row['field-type']) {
      case 'checkbox':
        const checkboxOptions = prepearGroup(row, 'checkbox', name)
        return checkboxOptions?.length > 0 && (
          <ErrorBoundary key={`preview-appointment-checkbox-${name}-ErrorBoundary`}>
            <Checkbox.Group
              key={`preview-appointment-checkbox-${name}`}
              options={checkboxOptions}
              disabled
            />
          </ErrorBoundary>
        );

      case 'radio':
        const radioOptions = prepearGroup(row, 'radio', name)
        return radioOptions?.length > 0 && (
          <ErrorBoundary key={`preview-appointment-radio-${name}-ErrorBoundary`}>
            <Radio.Group
              key={`preview-appointment-radio-${name}`}
              options={radioOptions}
              disabled
            />
          </ErrorBoundary>
        );

      default: <></>;
    }
  }, [appointments])

  return !!appointments && (
    <div {...rest} className={childClassNames}>
      <FBSectionHeader key={`preview-${type}`} type={type} />
      <div className='tcf-fb-group-preview__content'>
        <div className='form-header'>
          {!!appointments[`${type}-title`] && (
            <h3 className="form-title">{appointments[`${type}-title`]}</h3>
          )}
          {!!appointments[`${type}-description`] && (
            <p className="form-description">{appointments[`${type}-description`]}</p>
          )}
        </div>
        {appointments[`${type}-fields`]?.map((row, indx) => {
          const titleDate = formatDateTimeValue(row?.[`field-date`], dateFormat);
          return !!row && (
            <div key={`preview-appointment-form-row-${indx}`} className='form-row'>
              <h4 key={`preview-row-title-${type}-${indx}`} className={`form-row__title appointment ${row[`field-type`]}`}>
                <CustomIcons className="date-icon" type="calendar" />
                {titleDate}
              </h4>
              <div key={`preview-row-field-${type}-${indx}`} className='form-row__field'>
                {generatePreviewByType(row, indx)}
              </div>
            </div>
          );
        })}
      </div>

    </div>
  );
}

FBAppointmentPreview.defaultProps = {
  type: 'appointments',
};
FBAppointmentPreview.propTypes = {
  appointments: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
};

export default memo(FBAppointmentPreview);
